<template>
  <!-- <img alt="Vue logo" src="./assets/logo.png">
  <HelloWorld msg="Welcome to Your Vue.js App"/> -->
  <router-view></router-view>
  <ToastContainer/>
</template>

<script>
import { onMounted } from 'vue';
import ToastContainer from './components/ToastContainer.vue';
import { useAuth } from './composables/useAuth';

// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    ToastContainer
  },
  setup(){
    const {initAuth} = useAuth;
    onMounted(() =>{
      initAuth
    });
  }
}
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
</style>
